import { SERVICES, UI } from "../data/content";
import { Reveal, HeroBand, CapCard, ContactModule, RelatedLinks, usePageMeta } from "../components/kit";

export default function ServicesHub() {
  usePageMeta(
    `${UI.hubs.services.title} | KairosHK`,
    UI.hubs.services.standfirst
  );
  return (
    <div data-testid="services-hub-page">
      <HeroBand image="interchange" eyebrow={UI.nav.services} title={UI.hubs.services.title}
        standfirst={UI.hubs.services.standfirst}
        compact testId="services-hero" />
      <section className="k-section">
        <div className="k-container">
          <Reveal className="max-w-4xl mb-14">
            <p className="text-lg leading-relaxed mb-5">{UI.hubs.services.p1}</p>
            <p className="text-lg leading-relaxed text-ink-muted">{UI.hubs.services.p2}</p>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {SERVICES.map((s, i) => (
              <CapCard key={s.slug} to={`/services/${s.slug}`} title={s.name} body={s.card} i={i} testId={`service-card-${s.slug}`} />
            ))}
          </div>
          <Reveal className="mb-16">
            <RelatedLinks items={[[UI.hubs.relMarkets, "/markets"], [UI.hubs.relIssues, "/issues"]]} />
          </Reveal>
          <ContactModule />
        </div>
      </section>
    </div>
  );
}
